// english

export default {
  issue: 'Issue',
  // tab
  issue_tab_open: 'Open',
  issue_tab_closed: 'Closed',
  issue_tab_all: 'All',

  // status
  issue_status_open: 'Open',
  issue_status_pending: 'Pending',
  issue_status_closed: 'Closed',
  issue_status_reopen: 'Reopen',

  // btn
  issue_btn_add: 'New Issue',
  issue_btn_share_link: 'Share Link',
  issue_btn_reopen: 'Reopen Issue',
  issue_btn_close: 'Close Issue',

  // base
  issue_base_type: 'Category',
  issue_base_priority: 'Priority',
  issue_base_process: 'Process',
  issue_base_device: 'Device',
  issue_base_first_occurence: 'First Occurence',

  // 类型 , 问题类型(写死，value值一对一不要改，改了已存在的问题，它的类型就会乱了)
  issue_type_list: [
    {
      value: 1,
      name: 'Charging Issue',
    },
    {
      value: 2,
      name: 'Software Bug',
    },
    {
      value: 3,
      name: 'Hardware Defect',
    },
    {
      value: 4,
      name: 'Device-Independent Issue',
    },

    {
      value: 5,
      name: 'Other',
    },
  ],

  // 问题紧急程序
  issue_urgent_list: [
    {
      value: 0,
      name: 'OA',
    },
    {
      value: 1,
      name: 'MA',
    },
    {
      value: 2,
      name: 'CA',
    },
  ],

  // conifrm
  issue_confirm_close_title: 'Do you confirm to close this issue?',
  issue_confirm_content: 'Title: {title}',
  issue_confirm_reopen_title: 'Do you confirm to reopen this issue?',
  issue_confirm_delete_title: 'Do you confirm to delete this issue?',
  issue_confirm_delete_comment_title: 'Do you confirm to delete this comment?',

  // 匿名
  issue_anonymous: 'Anonymous',
  issue_anonymous_new: 'New Anonymous Issue',
  issue_anonymous_share: 'Share Anonymous Issue',
  issue_anonymous_share_url: 'URL',
  issue_anonymous_share_password: 'Password',
  issue_anonymous_share_copy_info: 'Copy Information',
  issue_anonymous_share_copy_password: 'Copy Password',
  issue_anonymous_share_copy_url: ' Copy URL',
  issue_anonymous_add: 'Add Anonymous Issue Link',
  issue_anonymous_add_success: 'Add new anonymous issue successfully',
  issue_anonymous_add_fail: 'Add new anonymous issue failed',
  issue_anonymous_edit_success: 'Edit issue successfully',
  issue_anonymous_edit_fail: 'Edit issue failed',

  // append
  issue_append_add: 'Add New Description',
  issue_append_edit: 'Edit Description',

  // comment
  issue_comment: 'Comment',
  issue_comment_add: 'Add Comment',
  issue_comment_edit: 'Edit Comment',
  issue_comment_contact: 'Contact',
  issue_comment_no_empty: "Comment can't be empty",

  // device
  issue_device_select: 'Select Devices',

  // form
  issue_form_title: 'Title',
  issue_form_title_placeholder: 'Please input title',
  issue_form_category: 'Category',
  issue_form_category_placeholder: 'Please select a issue category',
  issue_form_priority: 'Priority',
  issue_form_priority_placeholder: 'Please select a urgent type',
  issue_form_occurrence_time: 'Occurence Time',
  issue_form_occurrence_time_placeholder: 'Please select occurence time',
  issue_form_device: 'Belonged Device',
  issue_form_device_placeholder: 'Please select device',
  issue_form_device_select: 'Select Device',
  issue_form_device_soft_version: 'Software Version',
  issue_form_device_soft_version_placeholder: 'Please input software version',
  issue_form_site: 'Site',
  issue_form_site_all: 'All sites',
  issue_form_site_placeholder: 'Please select a site',
  issue_form_customer: 'Customer',
  issue_form_device2: 'Device',
  issue_form_device2_all: 'All Device',
  issue_form_type: 'Category',
  issue_form_type_placeholder: 'Please select a issue category',
};
